// avstemming-equity-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'avbe.page.noAccount': 'Egenkapitalområdet har ingen avstemmingskonto i denne perioden.',
  'avbe.accountingData': 'Regnskapsdata',
  'avbe.statement.title': 'Egenkapitaloppstilling',
  'avbe.nav.differences': '{count} differanse',
  'avbe.reconciled': 'Avstemt',
  'avbe.changes.title': 'Endringer i egenkapitalen',
  'avbe.nav.movements': '{count} bevegelser',
  'avbe.capital.title': 'Kapital og eiere',
  'avbe.nav.equityLiquidity': 'Egenkapital og likviditet',
  'avbe.nav.documentation': 'Dokumentasjon',
  'avbe.nav.missing': '{count} mangler',
  'avbe.complete': 'Komplett',
  'avbe.nav.itemsToAssess': 'Forhold til vurdering',
  'avbe.nav.open': '{count} åpne',
  'avbe.nav.controls': 'Kontroll og godkjenning',
  'avbe.areaLabel': 'Egenkapital',
  'avbe.page.hintOpen': '{count} forhold med varsel er ikke ferdig vurdert.',
  'avbe.page.hintAllDone': 'Alle forhold med varsel er vurdert.',
  'avbe.page.heading': 'Egenkapital — oppstilling, vedtak og forsvarlighet',
  'avbe.responsible': 'Ansvarlig {name}',
  'avbe.page.distNoBasis': '{count} utdeling uten beslutningsgrunnlag',
  'avbe.itemsNeedAssessment': '{count} forhold krever vurdering',
  'avbe.page.noOpenItems': 'Ingen åpne forhold',
  'avbe.page.unexplainedDiff': 'Egenkapitaloppstillingen har en uforklart beregningsdifferanse på {amount}.',
  'avbe.page.noCalcDeviation': 'Egenkapitalen er avstemt uten beregningsavvik.',
  'avbe.page.lossReduced': 'Periodens underskudd har redusert egenkapitalen med {amount}.',
  'avbe.page.profitIncreased': 'Periodens overskudd har økt egenkapitalen med {amount}.',
  'avbe.page.distMissingOne': '{count} utdeling mangler beslutningsgrunnlag.',
  'avbe.page.distMissingMany': '{count} utdelinger mangler beslutningsgrunnlag.',
  'avbe.page.ytdNote': 'Egenkapitalen avstemmes hittil i år: inngående balanse ved årets start, bevegelsene fram til periodeslutt, og utgående saldo ved periodeslutt. Registrert aksjekapital og kapitalendringer i Foretaksregisteret hentes ikke av appen og må kontrolleres manuelt.',
  'avbe.sources.title': 'Datakilder',
  'avbe.sources.missingOne': '{count} kilde er ikke på plass for året.',
  'avbe.sources.missingMany': '{count} kilder er ikke på plass for året.',
  'avbe.sources.allInPlace': 'Kildene avstemmingen leser er på plass for året.',
  'avbe.sources.source': 'Kilde',
  'avbe.status': 'Status',
  'avbe.details': 'Detaljer',
  'avbe.sources.unavailable': 'Ikke tilgjengelig',
  'avbe.sources.incomplete': 'Ikke komplett',
  'avbe.requestDocsClient': 'Be klienten om dokumentasjon',
  'avbe.group.paidIn': 'Innskutt egenkapital',
  'avbe.group.retained': 'Opptjent egenkapital',
  'avbe.overview.readFromLedger': 'Lest fra hovedboken {date}',
  'avbe.overview.bookedEquity': 'Bokført egenkapital på egenkapitalkontoer',
  'avbe.overview.accumulatedResult': 'Akkumulert perioderesultat',
  'avbe.overview.transferred': 'Overført til egenkapitalen',
  'avbe.overview.notTransferred': 'Ikke overført',
  'avbe.overview.computedInclResult': 'Beregnet egenkapital inkl. resultat',
  'avbe.overview.previousEquity': 'Egenkapital forrige periode',
  'avbe.overview.equityChange': 'Endring i egenkapital',
  'avbe.equityRatio': 'Egenkapitalandel',
  'avbe.overview.ratioSub': 'Vurderes sammen med risiko og likviditet',
  'avbe.overview.hideAccounts': 'Skjul kontooversikt',
  'avbe.overview.showAccounts': 'Vis kontooversikt',
  'avbe.account': 'Konto',
  'avbe.opening': 'Inngående',
  'avbe.additions': 'Tilgang',
  'avbe.disposals': 'Avgang',
  'avbe.closing': 'Utgående',
  'avbe.change': 'Endring',
  'avbe.vouchers': 'Bilag',
  'avbe.tile.noVoucher': 'Bevegelse uten bilagsdekning',
  'avbe.matches': 'Stemmer',
  'avbe.overview.accountsNote': 'Tilgang og avgang er summen av bilagene på kontoen hittil i år. Utgående er saldobalansens egen.',
  'avbe.tile.noDecisionBasis': 'Utdeling uten beslutningsgrunnlag',
  'avbe.tile.calcDifference': 'Beregningsdifferanse i oppstillingen',
  'avbe.tile.directPosting': 'Direkteføring mot egenkapital',
  'avbe.tile.ownerTransaction': 'Transaksjon med eier',
  'avbe.tile.negativeEquity': 'Negativ egenkapital',
  'avbe.tile.noShareCapital': 'Ingen bokført aksjekapital',
  'avbe.tile.noShareRegister': 'Aksjeeierbok ikke registrert',
  'avbe.control.title': 'Kontrollkort',
  'avbe.control.summary': '{checks} automatiske kontroller kjørt · {flagged} forhold krever vurdering · {done} ferdig vurdert',
  'avbe.control.categoriesReconciled': 'Egenkapitalkategorier avstemt',
  'avbe.control.categoriesOf': '{done} av {total}',
  'avbe.control.categoriesSub': 'Beregnet utgående mot bokført',
  'avbe.itemsRequireAssessment': 'Forhold som krever vurdering',
  'avbe.control.foundNothing': 'Kontrollene fant ingenting',
  'avbe.control.activeFilter': 'Aktivt filter: {label} · {count} forhold',
  'avbe.control.reset': 'Nullstill',
  'avbe.checks.title': 'Automatiske kontroller',
  'avbe.checks.note': 'Kontrollene krysser ikke av noe i den faglige sjekklista. De sier hva den som krysser av bør ha sett på.',
  'avbe.checks.check': 'Kontroll',
  'avbe.checks.run': 'Kjøring',
  'avbe.checks.findings': 'Funn',
  'avbe.checks.ran': 'Kjørt',
  'avbe.checks.findingsCount': '{count} funn',
  'avbe.checks.noFindings': 'Ingen funn',
  'avbe.statement.ytd': 'Hittil i år · {from}–{to}',
  'avbe.statement.category': 'Egenkapitalkategori',
  'avbe.statement.periodResult': 'Perioderesultat',
  'avbe.statement.computedClosing': 'Beregnet utgående',
  'avbe.statement.booked': 'Bokført',
  'avbe.difference': 'Differanse',
  'avbe.mustAssess': 'Må vurderes',
  'avbe.statement.zeroRows': '{count} øvrige egenkapitalkategorier har ingen saldo eller bevegelser.',
  'avbe.statement.showZero': 'Vis {count} nullposter',
  'avbe.statement.noBalance': 'Ingen saldo',
  'avbe.statement.hideZero': 'Skjul nullposter',
  'avbe.statement.sumBooked': 'Sum bokførte egenkapitalkontoer',
  'avbe.statement.resultTransferred': 'Perioderesultat overført til egenkapitalen',
  'avbe.statement.resultNotTransferred': 'Perioderesultat som ikke er overført',
  'avbe.statement.computedInclResult': 'Beregnet egenkapital inkludert resultat',
  'avbe.statement.noteTransferred': 'Perioderesultatet er overført til egenkapitalkontoene og er derfor ikke lagt til på nytt i beregningen.',
  'avbe.statement.noteNotTransferred': 'Perioderesultatet er ikke overført til egenkapitalkontoene og er derfor lagt til i beregnet egenkapital. Det er ikke telt dobbelt.',
  'avbe.statement.notePrevYear': 'Forrige års resultat inngår allerede i inngående egenkapital. Resultatdisponeringen fordeler beløpet mellom utbytte og annen opptjent egenkapital uten å legge resultatet til på nytt.',
  'avbe.changes.countOne': '{count} bevegelse hittil i år',
  'avbe.changes.countMany': '{count} bevegelser hittil i år',
  'avbe.changes.none': 'Ingen egenkapitaltransaksjoner er bokført hittil i år.',
  'avbe.date': 'Dato',
  'avbe.type': 'Type',
  'avbe.description': 'Beskrivelse',
  'avbe.amount': 'Beløp',
  'avbe.category': 'Kategori',
  'avbe.changes.counterAccount': 'Motkonto',
  'avbe.changes.decisionDate': 'Beslutningsdato',
  'avbe.changes.decisionBasis': 'Beslutningsgrunnlag',
  'avbe.changes.noCounterTitle': 'Bilaget har ingen motpostering utenfor egenkapitalen',
  'avbe.changes.noCounter': 'Ingen motkonto',
  'avbe.changes.notRequired': 'Ikke påkrevd',
  'avbe.documented': 'Dokumentert',
  'avbe.missing': 'Mangler',
  'avbe.changes.noAlert': 'Ingen varsel',
  'avbe.assessed': 'Vurdert',
  'avbe.seeAssessment': 'Se vurdering',
  'avbe.assess': 'Vurder',
  'avbe.changes.requestMinutes': 'Be om protokoll',
  'avbe.changes.note': 'Vurderingene bokfører ingenting. En korrigering føres på bilaget, og en utdeling som mangler vedtak løses av protokollen — ikke av en avkryssing her.',
  'avbe.quick.needsAssessment': 'Krever vurdering',
  'avbe.assessedDone': 'Ferdig vurdert',
  'avbe.quick.all': 'Alle',
  'avbe.items.resetFilters': 'Nullstill filtre',
  'avbe.items.noneInFilter': 'Ingen forhold i dette filteret.',
  'avbe.items.noneFound': 'Kontrollene fant ingen forhold som krever vurdering.',
  'avbe.items.item': 'Forhold',
  'avbe.items.alert': 'Varsel',
  'avbe.assessment': 'Vurdering',
  'avbe.action': 'Tiltak',
  'avbe.capital.limitedCompany': 'Aksjeselskap',
  'avbe.capital.legalFormUnset': 'Selskapsform ikke satt',
  'avbe.capital.bookedShareCapital': 'Bokført aksjekapital',
  'avbe.capital.bookedPremium': 'Bokført overkurs',
  'avbe.capital.ownShares': 'Egne aksjer',
  'avbe.capital.sharesInRegister': 'Antall aksjer i aksjeeierboka',
  'avbe.capital.shareholderCount': 'Antall aksjonærer',
  'avbe.capital.nominal': 'Pålydende per aksje',
  'avbe.capital.registeredCapital': 'Registrert aksjekapital (Foretaksregisteret)',
  'avbe.notFetched': 'Hentes ikke av appen',
  'avbe.capital.articles': 'Vedtekter',
  'avbe.capital.notUploaded': 'Ikke lastet opp',
  'avbe.capital.agmRecorded': 'Generalforsamling registrert',
  'avbe.capital.notRecorded': 'Ikke registrert',
  'avbe.capital.notFetchedNote': 'Plumme henter ikke registrert aksjekapital, kapitalendringer eller aksjonærregisteroppgave. Bokført aksjekapital må kontrolleres manuelt mot Foretaksregisteret og vedtektene.',
  'avbe.capital.shareholder': 'Aksjonær',
  'avbe.capital.shares': 'Aksjer',
  'avbe.capital.share': 'Andel',
  'avbe.capital.noRegister': 'Ingen aksjeeierbok er registrert i Plumme.',
  'avbe.capital.noRegisterHint': 'Be klienten om aksjeeierboka, eller registrer eierne i årsoppgjøret.',
  'avbe.disp.title': 'Disponering av resultatet for {year}',
  'avbe.disp.resolutionRecorded': 'Vedtak registrert',
  'avbe.disp.mathMatchesNoResolution': 'Bokføringen stemmer matematisk — vedtak mangler',
  'avbe.disp.bookedDeviates': 'Bokført disponering avviker fra årsresultatet',
  'avbe.disp.noneBooked': 'Ingen disponering bokført',
  'avbe.disp.item': 'Post',
  'avbe.disp.proposed': 'Foreslått',
  'avbe.disp.resolved': 'Vedtatt',
  'avbe.disp.notVerified': 'Ikke verifisert',
  'avbe.disp.prevResultUnreadable': 'Fjorårets årsresultat kunne ikke leses, og disponeringen kan derfor ikke sammenliknes med det.',
  'avbe.disp.sumsToResult': 'Bokført disponering summerer seg til forrige års resultat.',
  'avbe.disp.notSumsToResult': 'Bokført disponering summerer seg ikke til forrige års resultat.',
  'avbe.disp.noneBookedYtd': 'Ingen resultatdisponering er bokført hittil i år.',
  'avbe.disp.resolutionRecordedAt': 'Vedtaket er registrert på generalforsamlingen {date}.',
  'avbe.disp.cannotVerify': 'Vedtatt disponering kan ikke verifiseres før generalforsamlingen er registrert eller protokollen er mottatt.',
  'avbe.disp.requestAgmMinutes': 'Be kunden om generalforsamlingsprotokoll',
  'avbe.liq.title': 'Vurdering av egenkapital og likviditet',
  'avbe.liq.documented': 'Vurdering dokumentert',
  'avbe.computedEquity': 'Beregnet egenkapital',
  'avbe.liq.changeSincePrevious': 'Endring siden forrige periode',
  'avbe.liq.workingCapital': 'Arbeidskapital',
  'avbe.liq.liquidAssets': 'Likvide midler',
  'avbe.liq.overduePayables': 'Forfalt leverandørgjeld',
  'avbe.liq.items': '{count} poster',
  'avbe.yes': 'Ja',
  'avbe.no': 'Nei',
  'avbe.liq.bankData': 'Bankdata for året',
  'avbe.liq.budgetAvailable': 'Budsjett tilgjengelig',
  'avbe.liq.forecastAvailable': 'Likviditetsprognose tilgjengelig',
  'avbe.liq.noteSoundness': 'Vurderingen av forsvarlig egenkapital og likviditet må ses i sammenheng med virksomhetens risiko, omfang, likviditet og fremtidsutsikter. Plumme leverer grunnlaget — vurderingen gjøres av styret og regnskapsføreren.',
  'avbe.liq.noteFuture': 'Fremtidig utvikling kan ikke vurderes av tallene alene: verken budsjett eller likviditetsprognose er tilgjengelig for året.',
  'avbe.liq.confirmation': 'Vurdering og styrets bekreftelse',
  'avbe.liq.confirmationRequired': 'Vurdering og styrets bekreftelse (kreves)',
  'avbe.liq.confirmationPlaceholder': 'Hva viser gjennomgangen, og hva har styret bekreftet? Vis til styreprotokoll eller skriftlig bekreftelse.',
  'avbe.savedAsReason': 'Lagres som begrunnelsen på kontrollpunktet «{label}».',
  'avbe.liq.requestBoardAssessment': 'Be kunden om styrets vurdering',
  'avbe.docs.title': 'Dokumentasjon og beslutningsgrunnlag',
  'avbe.docs.basis': 'Grunnlag',
  'avbe.docs.inPlace': 'På plass',
  'avbe.requestDocsCustomer': 'Be kunden om dokumentasjon',
  'avbe.docs.attached': 'Vedlagt dokumentasjon',
  'avbe.docs.empty': 'Ingen dokumenter er lastet opp på egenkapitalområdet for denne perioden. Opplasting gjøres i dokumentfanen i høyrepanelet.',
  'avbe.derived.noDecisionBasis': 'Utdelinger uten beslutningsgrunnlag er behandlet',
  'avbe.derived.calcDifferences': 'Beregningsdifferanser i oppstillingen er behandlet',
  'avbe.derived.noVoucher': 'Bevegelser uten bilagsdekning er behandlet',
  'avbe.derived.directPostings': 'Direkteføringer mot egenkapital er vurdert',
  'avbe.derived.ownerTransactions': 'Transaksjoner med eiere er vurdert',
  'avbe.derived.negativeEquity': 'Signaler om negativ egenkapital er behandlet',
  'avbe.derived.noShareCapital': 'Manglende bokført aksjekapital er behandlet',
  'avbe.derived.noShareRegister': 'Manglende aksjeeierbok er behandlet',
  'avbe.checklist.title': 'Faglig sjekkliste',
  'avbe.checklist.titleReadOnly': 'Faglig sjekkliste (utførerens, skrivebeskyttet)',
  'avbe.checklist.none': 'Ingen kontrollpunkter er definert for egenkapital i denne perioden.',
  'avbe.checklist.note': 'Punktene gjelder hele egenkapitalområdet. En avkryssing lagres på alle egenkapitalkontoene i perioden.',
  'avbe.checklist.groupItems': 'Forhold som krever behandling',
  'avbe.checklist.countOf': '{done} av {total}',
  'avbe.checklist.handledOf': '{done} av {total} behandlet',
  'avbe.checklist.notApplicable': 'Ikke aktuelt denne perioden',
  'avbe.checklist.followsAssessments': 'Følger av vurderingene',
  'avbe.checklist.groupAssessments': 'Overordnede faglige vurderinger',
  'avbe.checklist.groupReady': 'Klarstilling',
  'avbe.checklist.performedBy': 'Utføres av {name}',
  'avbe.checklist.doneOfTotal': '{done} av {total} kontrollpunkter fullført',
  'avbe.blocker.distOne': 'Én utdeling mangler dokumentert beslutningsgrunnlag',
  'avbe.blocker.distMany': '{count} utdelinger mangler dokumentert beslutningsgrunnlag',
  'avbe.blocker.deviates': 'Beregnet egenkapital avviker fra bokført egenkapital',
  'avbe.blocker.assessmentUndocumented': 'Vurderingen av egenkapital og likviditet er ikke dokumentert',
  'avbe.blocker.checkpointOne': '{count} kontrollpunkt gjenstår',
  'avbe.blocker.checkpointMany': '{count} kontrollpunkter gjenstår',
  'avbe.conclusion.title': 'Konklusjon og godkjenning',
  'avbe.conclusion.changeThisPeriod': 'Endring denne perioden',
  'avbe.conclusion.unexplainedDiff': 'Uforklart beregningsdifferanse',
  'avbe.conclusion.transactions': 'Egenkapitaltransaksjoner',
  'avbe.conclusion.incompleteCheckpoints': 'Ufullførte kontrollpunkter',
  'avbe.conclusion.overallStatus': 'Samlet status',
  'avbe.conclusion.notReady': 'Ikke klar til kontroll',
  'avbe.conclusion.ready': 'Klar til kontroll',
  'avbe.conclusion.label': 'Konklusjon',
  'avbe.conclusion.placeholder': 'Hva viser gjennomgangen av egenkapitalen for denne perioden?',
  'avbe.conclusion.remainingRisk': 'Gjenstående risiko',
  'avbe.conclusion.nothingBlocking': 'Ingenting står igjen som hindrer at området sendes til kontroll. Registrert aksjekapital og kapitalendringer i Foretaksregisteret hentes ikke av appen og er kontrollert manuelt.',
  'avbe.followup.title': 'Oppfølging neste periode',
  'avbe.followup.none': 'Ingen vurderinger er merket for oppfølging neste periode.',
  'avbe.followup.badge': 'Følges opp',
  'avbe.followup.actionLine': 'Tiltak: {action}',
  'avbe.followup.noAction': 'Ingen tiltak notert',
  'avbe.followup.due': 'Frist {date}',
  'avbe.followup.open': 'Åpne vurdering',
  'avbe.conclusion.send': 'Send området til kontroll',
  'avbe.conclusion.oneThingLeft': 'Én ting står igjen før området kan sendes.',
  'avbe.conclusion.thingsLeft': '{count} ting står igjen før området kan sendes.',
  'avbe.assessments.notAssessed': 'Ikke vurdert',
  'avbe.assessments.decisionDocumented': 'Beslutningsgrunnlag mottatt og kontrollert',
  'avbe.assessments.decisionRequested': 'Beslutningsgrunnlag innhentes fra klienten',
  'avbe.assessments.appropriationToBook': 'Resultatdisponering skal bokføres',
  'avbe.assessments.reclassWithinEquity': 'Omklassifiseres innen egenkapitalen',
  'avbe.assessments.reclassToDebt': 'Omklassifiseres til gjeld eller fordring',
  'avbe.assessments.capitalChange': 'Kapitalendring skal registreres',
  'avbe.assessments.assessedWithBoard': 'Egenkapital og likviditet vurdert med styret',
  'avbe.assessments.noCorrection': 'Ingen korrigering nødvendig',
  'avbe.assessments.wrongBooking': 'Feil bokføring — korrigeres',
  'avbe.assessments.awaitingDocs': 'Avventer dokumentasjon',
  'avbe.assessments.awaitingClient': 'Avventer klienten',
  'avbe.followUpNext': 'Følges opp neste periode',
  'avbe.close': 'Lukk',
  'avbe.drawer.appliesTo': 'Gjelder',
  'avbe.drawer.rationaleRequired': 'Faglig begrunnelse (påkrevd)',
  'avbe.drawer.rationale': 'Faglig begrunnelse',
  'avbe.drawer.rationalePlaceholder': 'Hva gjelder forholdet, og hva bygger vurderingen på? Vis til protokoll, vedtak eller bilag.',
  'avbe.drawer.actionPlaceholder': 'F.eks. Innhent generalforsamlingsprotokoll, eller korriger bilaget',
  'avbe.drawer.followUpDue': 'Frist for oppfølging',
  'avbe.drawer.needsComment': 'Denne vurderingen krever en begrunnelse.',
  'avbe.drawer.save': 'Lagre vurdering',
});
